"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorContextPreprocessSetDefaultsLinkTraversal = void 0;
const bus_context_preprocess_1 = require("@comunica/bus-context-preprocess");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
/**
 * A comunica Set Defaults Link Traversal Context Preprocess Actor.
 */
class ActorContextPreprocessSetDefaultsLinkTraversal extends bus_context_preprocess_1.ActorContextPreprocess {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        let context = action.context;
        // Set traverse flag to true if the flag is undefined.
        if (!context.has(context_entries_1.KeysQuerySourceIdentify.traverse)) {
            context = context.set(context_entries_1.KeysQuerySourceIdentify.traverse, true);
        }
        return { context };
    }
}
exports.ActorContextPreprocessSetDefaultsLinkTraversal = ActorContextPreprocessSetDefaultsLinkTraversal;
//# sourceMappingURL=ActorContextPreprocessSetDefaultsLinkTraversal.js.map